import React, { createContext, useContext, useEffect, useState } from "react";
import { indexedDbAddData, indexedDbAddStore, indexedDbDeleteAllData, indexedDbDeleteData, indexedDbDeleteStore, indexedDbGetAllData, indexedDbGetData, indexedDbGetObjectStore, } from "../utils";
const IndexedDbContext = createContext(undefined);
const dbContainsStore = (db, store) => db.objectStoreNames.contains(store);
const checkForMissingStores = (db, stores) => {
    return (stores.filter(function (store) {
        return dbContainsStore(db, store);
    }).length > 0);
};
const initDB = (setIsReady, setDb, dbName, stores, version = 1, onError) => {
    const dbRequest = window.indexedDB.open(dbName, version);
    dbRequest.onupgradeneeded = (changeEvent) => {
        //@ts-ignore;
        const db = changeEvent.target.result;
        const existingStores = Array.from(db.objectStoreNames);
        const toRemove = existingStores.filter((store) => stores.includes(store));
        const promises = [];
        toRemove.forEach((store) => {
            promises.push(indexedDbDeleteStore(db, store));
        });
        stores.forEach((store) => {
            promises.push(indexedDbAddStore(db, store));
        });
        Promise.allSettled(promises).then((promises) => {
            setIsReady(true);
        });
    };
    dbRequest.onerror = (error) => {
        if (onError) {
            onError(error);
        }
    };
    dbRequest.onsuccess = (success) => {
        //@ts-ignore;
        const db = success.target.result;
        setDb(db);
        setIsReady(true);
    };
    return dbRequest;
};
const IndexedDbProvider = ({ dbName, version, stores, onError, children, }) => {
    const [isReady, setIsReady] = useState(false);
    const [db, setDb] = useState();
    const getObjectStore = (objectStoreName) => {
        return indexedDbGetObjectStore(db, objectStoreName);
    };
    const addData = (objectStoreName, data, key) => {
        return indexedDbAddData(db, objectStoreName, data, key);
    };
    const getData = (objectStoreName, key) => {
        return indexedDbGetData(db, objectStoreName, key);
    };
    const getAllData = async (objectStoreName) => {
        return indexedDbGetAllData(db, objectStoreName);
    };
    const deleteData = async (objectStoreName, key) => {
        return indexedDbDeleteData(db, objectStoreName, key);
    };
    const deleteAllData = async (objectStoreName) => {
        return indexedDbDeleteAllData(db, objectStoreName);
    };
    useEffect(() => {
        initDB(setIsReady, setDb, dbName, stores, version, onError);
    }, [dbName, stores, onError]);
    return (React.createElement(IndexedDbContext.Provider, { value: {
            isReady,
            addData,
            getData,
            getAllData,
            deleteData,
            deleteAllData,
            checkForMissingStores,
        } }, children));
};
const useIndexedDB = () => {
    const indexedDbContext = useContext(IndexedDbContext);
    if (indexedDbContext === undefined) {
        throw new Error(`useIndexedDB must be used within a IndexedDbProvider`);
    }
    return indexedDbContext;
};
export { IndexedDbContext, IndexedDbProvider, useIndexedDB };
//# sourceMappingURL=useIndexedDB.js.map